var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1695_6268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.60172 2.18112L3.85172 17.9683H1.84171L1.06171 2.18112H4.60172ZM1.45171 23.8651C1.07171 23.4699 0.881714 22.9915 0.881714 22.4299C0.881714 21.8683 1.07171 21.3899 1.45171 20.9947C1.83171 20.5787 2.29171 20.3707 2.83171 20.3707C3.37172 20.3707 3.83172 20.5787 4.21172 20.9947C4.61172 21.3899 4.81172 21.8683 4.81172 22.4299C4.81172 22.9915 4.61172 23.4699 4.21172 23.8651C3.83172 24.2603 3.37172 24.4579 2.83171 24.4579C2.29171 24.4579 1.83171 24.2603 1.45171 23.8651Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1695_6268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 26,
    fill: "white",
    transform: "translate(0.339966 0.901924)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/notice-icon.6788dd258d1f649a3101c51b37e311aa.svg";
export { ForwardRef as ReactComponent };